import { useTranslation } from '@/contexts/i18n-context';
import emptyListState from '@/img/empty-list-state.svg';
import { TranslationKey } from '@/contexts/translations';
import { EmptyListWrapper } from './empty-list-wrapper';

interface EmptyListProps {
  title: TranslationKey;
}

const translationBase = 'visit.emptyList';

export function EmptyList({ title }: EmptyListProps) {
  const { t } = useTranslation();

  return (
    <EmptyListWrapper
      title={t(title)}
      subtitle={t(`${translationBase}.subTitle`)}
      icon={{ src: emptyListState, alt: t(`${translationBase}.iconAlt`) }}
    />
  );
}
